import React, {Component} from 'react';
import Input from "../../elements/components/form/Input";
import Select from "../../elements/components/form/Select"

export default class RoomCountFilter extends Component {
    handleChange = (type, value) => {
        const { onChangeFilter } = this.props;

        if (type === 'min') {
            onChangeFilter({roomMin: value})
        } else {
            onChangeFilter({roomMax: value})
        }
    }

    isSelectSearchable = () => {
        return window.innerWidth > 767
    }

    render() {
        return (
            <div className="filter-with-title">
                <div className="filter-title">
                    {this.props.translations['room-count']}
                </div>
                <div className="filter-rooms">
                    <Select
                        isValueInherited={true}
                        inheritedValue={this.props.minValue}
                        optionsAmount={5}
                        placeholder={this.props.translations['input-from']}
                        onChange={value => this.handleChange('min', value)}
                        isSearchable={this.isSelectSearchable()}
                    />
                    <Select
                        isValueInherited={true}
                        inheritedValue={this.props.maxValue}
                        optionsAmount={5}
                        placeholder={this.props.translations['input-to']}
                        onChange={value => this.handleChange('max', value)}
                        isSearchable={this.isSelectSearchable()}
                    />
                </div>
            </div>
        )
    }
}